// extracted by mini-css-extract-plugin
export default {"createDesignHeader":"CreateDesignMainPage_createDesignHeader__GRBWF","designersHelp":"CreateDesignMainPage_designersHelp__vkLFI","contactUs":"CreateDesignMainPage_contactUs__cS470"};